import { useQuery } from "@vue/apollo-composable";

import { GET_APP_VERSION, type AppVersionQueryResult } from "./app.gql";

export const useAppVersionQuery = () =>
  useQuery<AppVersionQueryResult, Record<string, never>>(GET_APP_VERSION);
